import React from 'react';

type WebflowRoutes = 'default' | 'pca' | 'bca' | 'sta';

export type WebflowContextStateType = {
  route?: WebflowRoutes;
  hideCta: boolean;
};

const OnboardingContext = React.createContext<WebflowContextStateType>({
  hideCta: false
});

OnboardingContext.displayName = 'OnboardingContext';

export default OnboardingContext;
